"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("@angular/common/http");
const harmony_core_1 = require("@mobilejazz/harmony-core");
const operators_1 = require("rxjs/operators");
class HttpRequestBuilder {
    constructor(endpoint, http) {
        this.http = http;
        this.body = '';
        this.headers = new http_1.HttpHeaders();
        this.urlBuilder = new harmony_core_1.UrlBuilder(endpoint);
        this.setDefaultHeaders();
    }
    setUrlParameters(urlParameters) {
        this.urlBuilder.setUrlParameters(urlParameters);
        return this;
    }
    setQueryParameters(queryParameters) {
        this.urlBuilder.setQueryParameters(queryParameters);
        return this;
    }
    setBody(body) {
        this.body = JSON.stringify(body);
        return this;
    }
    setHeaders(headers) {
        Object.keys(headers).forEach((key) => {
            this.headers = this.headers.append(key, headers[key]);
        });
        return this;
    }
    setResponseConstructor(responseConstructor) {
        this.responseConstructor = responseConstructor;
        return this;
    }
    setDefaultHeaders() {
        const defaultHeaders = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
        this.setHeaders(defaultHeaders);
    }
    mapResponse(responseItem) {
        const mapper = new harmony_core_1.JsonDeserializerMapper(this.responseConstructor);
        return mapper.map(responseItem);
    }
    get() {
        return this.http
            .get(this.urlBuilder.getUrl(), { observe: 'response', headers: this.headers })
            .pipe(operators_1.map((response) => {
            if (!response.body) {
                return null;
            }
            if (!this.responseConstructor) {
                return response.body;
            }
            if (response.body instanceof Array) {
                return response.body.map((responseItem) => {
                    return this.mapResponse(responseItem);
                });
            }
            return this.mapResponse(response.body);
        }));
    }
    post() {
        return this.http
            .post(this.urlBuilder.getUrl(), this.body, { observe: 'response', headers: this.headers })
            .pipe(operators_1.map((response) => {
            if (!response.body) {
                return null;
            }
            if (!this.responseConstructor) {
                return response.body;
            }
            if (response.body instanceof Array) {
                return response.body.map((responseItem) => {
                    return this.mapResponse(responseItem);
                });
            }
            return this.mapResponse(response.body);
        }));
    }
    put() {
        return this.http
            .put(this.urlBuilder.getUrl(), this.body, { observe: 'response', headers: this.headers })
            .pipe(operators_1.map((response) => {
            if (!response.body) {
                return null;
            }
            if (!this.responseConstructor) {
                return response.body;
            }
            if (response.body instanceof Array) {
                return response.body.map((responseItem) => {
                    return this.mapResponse(responseItem);
                });
            }
            return this.mapResponse(response.body);
        }));
    }
    delete() {
        return this.http
            .delete(this.urlBuilder.getUrl(), { observe: 'response', headers: this.headers })
            .pipe(operators_1.map((response) => {
            return;
        }));
    }
}
exports.HttpRequestBuilder = HttpRequestBuilder;
